type CostVersusOutputMeasures =
  | 'cost'
  | 'daily_burn'
  | 'cost_per_point'
  | 'cost_per_task'
  | 'committed_points'
  | 'completed_points'
  | 'committed_tasks'
  | 'completed_tasks';

type AllocationOfCostsMeasures =
  | 'epic'
  | 'type'
  | 'label'
  | 'points'
  | 'sprint'
  | 'assignee'
  | 'due_date'
  | 'priority'
  | 'reporter'
  | 'component'
  | 'current_section';

type AgentCostsCategory = 'general' | 'users' | 'epics' | 'initiatives';

enum ViewBy {
  Points = 'points',
  Tasks = 'tasks',
  TasksInUSD = 'tasks_in_usd',
  PointsInUSD = 'points_in_usd',
}

type State = {
  viewBy: ViewBy;
  chart: Charts;
  team: string | null;
  board: string | null;
  startDate: Date | null;
  endDate: Date | null;
  workPeriodIds: string[];
  filters: Filters;
  table: {
    selectedYear: number | null;
    searchTerm: string | undefined;
  };
};

type Filters = {
  costVersusOutput: {
    selectedChartType: ChartType;
    selectedMeasures: CostVersusOutputMeasures[];
    selectedTrendLines: CostVersusOutputMeasures[];
  };
  allocationOfCosts: {
    selectedChartType: ChartType;
    selectedMeasure: AllocationOfCostsMeasures;
    selectedOptions: string[];
    selectedTrendLines: string[];
  };
  costByInitiative: {
    selectedChartType: ChartType;
    selectedInitiativeIds: string[];
    selectedTrendLines: string[];
  };
  agentCosts: {
    selectedChartType: ChartType;
    viewBy: 'cost' | 'tokens';
    selectedCategory: AgentCostsCategory;
    selectedOptions: string[];
    selectedTrendLines: string[];
    selectedAgentSource: string;
  };
};

enum View {
  Charts = 'charts',
  Table = 'table',
}

enum Charts {
  CostVersusOutput = 'costVersusOutput',
  AllocationOfCosts = 'allocationOfCosts',
  CostByInitiative = 'costByInitiative',
  AgentCosts = 'agentCosts',
}

enum ChartType {
  Line = 'line',
  Bar = 'bar',
  Pie = 'pie',
}

export { Charts, ChartType, View, ViewBy };
export type { AgentCostsCategory, AllocationOfCostsMeasures, CostVersusOutputMeasures, State };
